import  React from 'react';
import styles from './styles.module.scss';

export const PromoBlock = ()=>(
    <div className={ styles.container }>
        <div className={ styles.wrapper }>
            Среднее снижение цены на сертификацию по итогам торгов - 76%
        </div>
    </div>
);